import AnnotationDetails from './AnnotationDetails';
export default AnnotationDetails;
